import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

import { getFileUploadTypes } from '../../../utils/utilities';
import Conditional from '../../common/conditional';

class CertificateForm extends Form {
	state = {
		data: {
			training: [],
			calibration: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		training: Joi.array().min(1).max(1).required().label('Inspector NDT Level 2 Certificate or Training Certificate'),
		calibration: Joi.array().min(0).max(1).required().label('Equipment Calibration Certificate'),
	};

	static propTypes = {
		initialData: PropTypes.object,
		onSave: PropTypes.func,
		calibrationRequired: PropTypes.bool,
	};

	componentDidMount(): void {
		if (this.props.initialData) {
			this.setState({ data: this.props.initialData });
		}	

		if (this.props.calibrationRequired) {
        	this.schema.calibration = Joi.array().min(1).max(1).required().label('Equipment Calibration Certificate');
    	} else {
	        this.schema.calibration = Joi.array().max(1).optional().label('Equipment Calibration Certificate');
	    }
	}

	doSubmit = (): void => {
		this.props.onSave(this.state.data);
		toastService.success('Certficiates Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'training',
							accept: 'image/*,application/pdf',
							label: 'Inspector NDT Level 2 Certificate or Training Certificate',
							sublabel: 'Upload Inspector NDT Level 2 Certificate or Training Certificate',
							types: getFileUploadTypes(),
						})}
					</div>

					<Conditional isVisible={this.props.calibrationRequired}>
						<div className="col">
							{this.renderFileInput({
								max: 1,
								multiple: false,
								name: 'calibration',
								accept: 'image/*,application/pdf',
								label: 'Equipment Calibration Certificate',
								sublabel: 'Upload Equipment Calibration Certificate',
								types: getFileUploadTypes(),
							})}
						</div>
					</Conditional>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Certificates')}
				</div>
			</form>
		);
	}
}

export default CertificateForm;
